// Wird beim Abbrechen/Schliessen eines Brokerage-Dialogs (Close-Icon/ESC)
// aufgerufen, damit eine bereits offene comdirect-Verbindung (vorlaeufiger
// Token waehrend TAN-Eingabe, oder fertiger Token fuer eine noch nicht
// abgesendete Order) sofort widerrufen wird, statt nur passiv abzulaufen
// (Chat vom 2026-07-26). Feuert den Widerruf im Hintergrund (kein Warten auf
// die Antwort - das Schliessen der UI soll sich nicht durch einen
// Netzwerk-Roundtrip verzoegern) und ruft danach sofort den eigentlichen
// onCancel/onClose des Aufrufers auf.
export default function cancelBrokerageSession(x, connectionId, onCancel) {
	if (connectionId) {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BrokerageCancelSession', { connectionId }, () => {});
	}
	if (onCancel) onCancel();
}
